import { useState } from "react";

export const useInitialState = (initialState) => {
	const [state] = useState(initialState);
	return state;
};
